import React, { Component } from 'react';
import { Prompt } from 'react-router';
import { connect } from 'react-redux';
import * as actions from 'actions/vendor-request';
import * as Yup from 'yup';
import { fetchAllDepartments } from 'actions/utils';
import Loading from 'components/loading';
import {
  Container,
  HeaderFlexRow,
  HeadingTitle,
  PlainButton,
} from 'components/styled-components';
import VendorInfo from 'components/vendor-requests/vendor-info';
import Scores from 'components/vendor-requests/scores';
import CategoryScores from 'components/vendor-requests/categoryScores';
import DepartmentalReviews from 'components/vendor-requests/departmental-reviews';
import RequestInfo from 'components/vendor-requests/request-info';
import SponsorInfo from 'components/vendor-requests/sponsor-info';
import PrescreenInfo from 'components/vendor-requests/prescreen-info';
import Notes from 'components/vendor-requests/notes';
import {
  NonIdealState,
  Button,
  Intent,
  Tooltip,
  Position,
} from '@blueprintjs/core';
import styled from 'styled-components';
import { fetchScores } from 'actions/questionnaire';
import { fetchUploadedFiles } from 'actions/utils';
import { updateScore } from 'api/questionnaire';
import colors from 'utils/colors';
import hasPermission from 'utils/hasPermission';
import QuestionnaireInfo from 'components/vendor-requests/questionnaire-info';
import StatusLog from 'components/vendor-requests/status-log';
import AuditLog from 'components/vendor-requests/audit-log';
import Documents from 'components/vendor-requests/documents';
import { updateVendorRequest, submitDepartmentalReview, submitSendReviewNotice, testReviewAPI } from 'api/vendor-request';
import { AppToaster } from 'components/AppToaster';
import pickBy from 'lodash/pickBy';
import permissions from 'utils/permissions';
import map from 'lodash/map';
import isEqual from 'lodash/isEqual';
import find from 'lodash/find';
import { Formik, Form } from 'formik';
import cloneDeep from 'lodash/cloneDeep';
import { ErrorMessage } from 'formik';
import { DialogWrapper } from 'components/DialogWrapper';
import { Remove } from 'containers/Manage-Questionnaire/styled-components';
import DepartmentalReviewDrawer from 'containers/Manage-Requests/Drawers/DepartmentalReviewDrawer';

const ValidationSchema = Yup.object().shape({
  sponsorInformation: Yup.object()
    .shape({
      userID: Yup.number(),
      email: Yup.string()
        .email('Invalid email')
        .required('Required'),
      department: Yup.string(),
    })
    .required('Must have a sponsor'),
  departmentsRequesting: Yup.array()
    .min(1, 'Select at least one requesting department')
    .required(),
  vendorInformation: Yup.object()
    .required('Must have a Third Party')
    .nullable(),
  productServiceName: Yup.mixed()
    .required('Must have a Product/Service')
    .nullable(),
  vendorContact: Yup.array().of(Yup.object({
    firstName: Yup.string()
      .min(1, 'Too Short!')
      .max(200, 'Too Long!')
      .required('Required')
      .nullable(),
    lastName: Yup.string()
      .min(1, 'Too Short!')
      .max(200, 'Too Long!')
      .required('Required')
      .nullable(),
    email: Yup.string()
      .min(1, 'Too Short!')
      .max(200, 'Too Long!')
      .email('Invalid email')
      .required('Required')
      .nullable(),
    userID: Yup.number(),
  }))
    .nullable()
    .required('Must have a Third Party contact'),
  requestStatus: Yup.mixed().required('Required: Assessment Status'),
  overrideNote: Yup.string().when('requestStatus', {
    is: val => {
      const status = typeof val === 'string' ? val : val.statusName;
      return (
        status === 'Manual Approval' ||
        status === 'Manual Denied' ||
        status === 'Conditional Approval'
      );
    },
    then: Yup.string()
      .min(1, 'Too Short!')
      .max(500, 'Too Long!')
      .required('Required: Override Note')
      .nullable(),
    otherwise: Yup.string()
      .notRequired()
      .nullable(),
  }),
});

const initialState = {
  editing: false,
  scores: [],
  updatedScores: [],
  width: '100%',
  departmentalReviewOpen: false,
  selectedReview: false,
};

const compareCurrentToOriginal = (current, original) => {
  return isEqual(current, original) ? null : current;
};

const compareCurrentToOriginalArray = (current, original) => {
	if(current.length != original.length) return current;
	let different = false;
	current.forEach(c => {
		if(!original.includes(c))
			different = true;
	});
	original.forEach(c => {
		if(!current.includes(c))
			different = true;
	});
	if(different)
		return current;
	return null;
}

class ManageVendorRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
      inactivateAssessment: false,
    };
  }

  componentDidMount() {
    const { requestID } = this.props.match.params;
    this.props.fetchVendorRequest(requestID);
    this.props.fetchUploadedFiles(requestID);
    this.props.fetchAllDepartments();

    if (
      hasPermission(this.props.appUser.permissions, [permissions.VIEW_SCORES])
    ) {
      this.props.fetchScores(requestID);
    }
    this.setWidthByPermission();
  }

  componentDidUpdate(_, prevState) {
    if (
      !prevState.scores.length &&
      this.props.scoresLoaded &&
      this.props.questionTypeScores.length
    ) {
      this.setState({
        scores: [
          ...this.props.questionTypeScores,
          ...this.props.displayCategoriesScores,
        ],
      });
    }
  }

	openDepartmentalReview = (SelectedReviewID) => {
		const selectedReview = 	this.props.request.DepartmentalReviews.filter(dr => dr.ReviewID == SelectedReviewID);
		return this.setState({
			departmentalReviewOpen: true,
			selectedReview: selectedReview.length > 0 ? selectedReview[0] : false
		});
	};
	closeDepartmentalReview = () => {
		return this.setState({ departmentalReviewOpen: false, selectedReview: false })
	};

  setWidthByPermission = () => {
    const { appUser } = this.props;
    const newWidth = hasPermission(appUser.permissions, [
      permissions.VIEW_REQUEST_ATTACHMENT,
      permissions.VIEW_ALL_REQUEST_ATTACHMENT,
    ])
      ? '65%'
      : '100%';
    this.setState({ width: newWidth });
  };

  shouldBlockNavigation = () => {
    return this.state.editing;
  };

  toggleEdit = () => this.setState({ editing: !this.state.editing });

  handleUpdateScores = scores => {
    this.setState({ scores });
  };

  handleCancelClick = reset => {
    reset();
    this.setState({
      editing: false,
      scores: [
        ...this.props.questionTypeScores,
        ...this.props.displayCategoriesScores,
      ],
    });
  };

  handleDismissInactivateAssessment = () =>
    this.setState({ inactivateAssessment: false });
  openInactivateAssessmentDialog = () =>
    this.setState({ inactivateAssessment: true });

  handleInactivate = () => {
    const { requestID } = this.props.match.params;
    const inactiveStatus = this.props.requestStatuses.filter(
      status => status.statusName === 'Inactive'
    )[0];
    updateVendorRequest(requestID, {
      vendorRequestStatus: inactiveStatus.vendorRequestStatusID,
    })
      .then(res => {
        this.toggleEdit();
        this.props.fetchVendorRequest(requestID);
        AppToaster.show({
          message: res.data.message,
          intent: Intent.SUCCESS,
        });
        this.setState({ inactivateAssessment: false, editing: false });
      })
      .catch(err => {
        AppToaster.show({
          message: err.response.data.message,
          intent: Intent.DANGER,
        });
        this.setState({ inactivateAssessment: false, editing: false });
      });
  };

  handleSave = (values, actions) => {
    actions.setSubmitting(true);
    const { requestID } = this.props.match.params;
    const { request } = this.props;
    const vendorRequestStatus = () => {
      const { requestStatus } = values;
      if (requestStatus) {
        return typeof requestStatus === 'string'
          ? null
          : requestStatus.vendorRequestStatusID;
      } else {
        return null;
      }
    };

    const departmentsRequesting =
      values.departmentsRequesting &&
      typeof values.departmentsRequesting[0] !== 'string' &&
      values.departmentsRequesting.map(d => d.departmentID);

    const productServiceName = () => {
      const psn = compareCurrentToOriginal(
        values.productServiceName.value,
        request.productServiceName
      );
      if (psn) {
        return psn;
      } else {
        return null;
      }
    };

    const requestBody = {
      vendorRequestStatus: vendorRequestStatus(),
      departmentsRequesting,
      productServiceName: productServiceName(),
      sponsorID: compareCurrentToOriginal(
        values.sponsorInformation.userID,
        request.sponsorInformation.userID
      ),
      vendorID: compareCurrentToOriginal(
        values.vendorInformation.vendorID,
        request.vendorInformation.vendorID
      ),
      vendorContactID: compareCurrentToOriginalArray(
        values.vendorContact.map(vc => vc.userID),
        request.vendorContact.map(vc => vc.userID)
      ),
      renewalDate: compareCurrentToOriginal(
        values.renewalDate,
        request.renewalDate
      ),
      approvalDate: compareCurrentToOriginal(
        values.approvalDate,
        request.approvalDate
      ),
      description: compareCurrentToOriginal(
        values.description,
        request.description
      ),
      reqPoInvoice: compareCurrentToOriginal(
        values.reqPoInvoice,
        request.reqPoInvoice
      ),
      overrideNote: compareCurrentToOriginal(
        values.overrideNote,
        request.overrideNote
      ),
    };
    if (Object.keys(pickBy(requestBody)).length) {
      updateVendorRequest(requestID, pickBy(requestBody))
        .then(res => {
          this.toggleEdit();
          this.props.fetchVendorRequest(requestID);
          actions.setSubmitting(false);
          AppToaster.show({
            message: res.data.message,
            intent: Intent.SUCCESS,
          });
        })
        .catch(err => {
          actions.setSubmitting(false);
          AppToaster.show({
            message: err.response.data.message,
            intent: Intent.DANGER,
          });
        });
    } else {
      this.toggleEdit();
    }

    if (this.state.scores.length) {
      const promisedScoreUpdates = map(this.state.scores, score => {
        const originalScore = find(
          [
            ...this.props.questionTypeScores,
            ...this.props.displayCategoriesScores,
          ],
          ['questionnaireScoreID', score.questionnaireScoreID]
        );
        if (compareCurrentToOriginal(score.score, originalScore.score)) {
          return new Promise((resolve, reject) => {
            updateScore(score.questionnaireScoreID, {
              score: Number(score.score),
              sectionName: score.typeName
                ? score.typeName
                : score.categoryName
                ? score.categoryName
                : null,
              vendorRequestID: parseInt(requestID),
            })
              .then(res => resolve(res))
              .catch(err => reject(err));
          });
        }
      });

      Promise.all(promisedScoreUpdates)
        .then(() => {
          this.props.fetchScores(this.props.match.params.requestID);
          this.props.fetchVendorRequest(requestID);
        })
        .catch(err =>
          AppToaster.show({
            message: err.response.data.message,
            intent: Intent.DANGER,
          })
        );
    }
  };

  handleSaveReview = (review) => {
	  return submitDepartmentalReview(review)
	  	.then(res => {
			AppToaster.show({
				message: res.data.message,
				intent: Intent.SUCCESS,
			});
			this.closeDepartmentalReview();
			this.props.fetchVendorRequest(this.props.match.params.requestID);
		})
		.catch(err => {
			AppToaster.show({
				message: err.response.data.message,
				intent: Intent.DANGER,
			});
		});
  }

	handleSendReviewNotice = (VendorRequestID, DepartmentID) => {
		return submitSendReviewNotice(VendorRequestID, DepartmentID)
			.then(res => {
				AppToaster.show({
					message: "Review notice sent.",
					intent: Intent.SUCCESS
				});
			})
			.catch(err => {
				AppToaster.show({
					message: err.response.data.message,
					intent: Intent.DANGER
				});
			});
	}

  render() {
    const { width } = this.state;
    const {
      vendorInformation,
      vendorContact,
      productServiceName,
      requestStatus,
      departmentsRequesting,
      rejectionNote,
      approvalDate,
      renewalDate,
      requestSubmittedDate,
      sponsorInformation,
      description,
      reqPoInvoice,
      overrideNote,
      prescreenAccepted,
    } = cloneDeep(this.props.request);
    const { request, appUser } = this.props;
    const modifyAll = hasPermission(appUser.permissions, [
      permissions.MODIFY_ALL_THIRD_PARTY_REQUESTS,
    ]);
    const requestAproval = hasPermission(appUser.permissions, [
      permissions.VIEW_REQUEST_APPROVAL,
    ]);

    if (this.props.isFetching) return <Loading size={200} />;
    if (this.props.isError)
      return (
        <NonIdealState
          icon="error"
          title="Unable to load the Request"
          description={
            <>
              The system did not find the Third Party assessment. <br />
              Try creating a new one.
            </>
          }
        />
      );
    const { editing } = this.state;
    if (this.props.loaded) {
      return (
        <React.Fragment>
          <Prompt
            when={this.shouldBlockNavigation()}
            message="You have unsaved changes, are you sure you want to leave?"
          />
          <Formik
            enableReinitialize={true}
            initialValues={{
              vendorInformation,
              vendorContact,
              productServiceName,
              requestStatus,
              departmentsRequesting,
              rejectionNote,
              approvalDate,
              renewalDate,
              requestSubmittedDate,
              sponsorInformation,
              description,
              reqPoInvoice,
              overrideNote,
            }}
            validationSchema={ValidationSchema}
            onSubmit={this.handleSave}
            isInitialValid
          >
            {({
              isSubmitting,
              values,
              handleChange,
              setFieldValue,
              resetForm,
              isValidating,
              isValid,
              setTouched,
              setFieldTouched,
            }) => (
              <Form>
                <div style={{ display: 'none' }}>
                  {isValidating &&
                    isSubmitting &&
                    Object.keys(values).map(value => (
                      <ErrorMessage
                        key={value}
                        name={value}
                        render={message => {
                          return AppToaster.show({
                            message,
                            intent: Intent.DANGER,
                          })
							}
                        }
                      />
                    ))}
                </div>
                <Container paddingBottom="2rem">
                  <HeaderFlexRow>
                    <HeadingTitle>Third Party Assessment Details</HeadingTitle>
                    <div>
                      {hasPermission(this.props.appUser.permissions, [
                        permissions.MODIFY_ALL_THIRD_PARTY_REQUESTS,
                        permissions.MODIFY_OWNED_THIRD_PARTY_REQUESTS,
                      ]) &&
                        requestStatus !== 'Third Party Dispute' &&
                        requestStatus !== 'Inactive' &&
                        !editing && (
                          <Button
                            minimal
                            large
                            text="Inactivate Assessment"
                            type="button"
                            style={{
                              color: colors.red,
                              borderStyle: 'solid',
                              borderWidth: '1px',
                              borderColor: colors.red,
                            }}
                            onClick={this.openInactivateAssessmentDialog}
                          />
                        )}

                      {hasPermission(this.props.appUser.permissions, [
                        permissions.MODIFY_ALL_THIRD_PARTY_REQUESTS,
                      ]) &&
                        requestStatus !== 'Third Party Dispute' &&
                        !editing && (
                          <PlainButton
                            type="button"
                            onClick={() => {
                              this.toggleEdit();
                              setTouched({ overrideNote: true });
                            }}
                          >
                            EDIT
                          </PlainButton>
                        )}
                      {hasPermission(this.props.appUser.permissions, [
                        permissions.MODIFY_OWNED_THIRD_PARTY_REQUESTS,
                      ]) &&
                        requestStatus !== 'Third Party Dispute' &&
                        !editing &&
                        (this.props.request.sponsorInformation &&
                        this.props.request.sponsorInformation.userID ===
                          this.props.appUser.userID ? (
                          <PlainButton
                            type="button"
                            onClick={() => {
                              this.toggleEdit();
                              setTouched({ overrideNote: true });
                            }}
                          >
                            EDIT
                          </PlainButton>
                        ) : (
                          <Tooltip
                            content={
                              <>
                                You must be the sponsor of
                                <br />
                                an assessment to modify it.
                              </>
                            }
                            position={Position.BOTTOM}
                          >
                            <PlainButton
                              disabled
                              type="button"
                              onClick={this.toggleEdit}
                            >
                              EDIT
                            </PlainButton>
                          </Tooltip>
                        ))}
                    </div>
                    {hasPermission(this.props.appUser.permissions, [
                      permissions.MODIFY_OWNED_THIRD_PARTY_REQUESTS,
                      permissions.MODIFY_ALL_THIRD_PARTY_REQUESTS,
                    ]) &&
                      editing && (
                        <div>
                          <Button
                            minimal
                            large
                            text="Cancel"
                            type="button"
                            onClick={() => this.handleCancelClick(resetForm)}
                          />
                          <PlainButton
                            type="submit"
                            disabled={isSubmitting || !isValid}
                          >
                            SAVE
                          </PlainButton>
                        </div>
                      )}
                  </HeaderFlexRow>
                  <BlueSection>
                    <VendorInfo
                      request={request}
                      values={values}
                      editing={this.state.editing}
                      handleUpdateTextField={handleChange}
                      handleUpdateSelect={setFieldValue}
                      handleUpdateVendorInformation={setFieldValue}
                      setFieldValue={setFieldValue}
                      vendorID={
                        request.vendorInformation &&
                        request.vendorInformation.vendorID
                      }
                      appUser={appUser}
                      setFieldTouched={setFieldTouched}
                    />
                    {hasPermission(this.props.appUser.permissions, [
                      permissions.VIEW_SCORES,
                    ]) ? (
                      <Scores
                        editing={this.state.editing}
                        stateScores={this.state.scores}
                        handleUpdateScores={this.handleUpdateScores}
                        scores={this.props.questionTypeScores}
                        title="Scores by Question Type"
                        propertyKey="typeName"
                        scoresLoaded={this.props.scoresLoaded}
                        modifyAll={modifyAll}
                      />
                    ) : (
                      <>
                        <div style={{ width: '33%' }} />
                        <div style={{ width: '33%' }} />
                      </>
                    )}
                  </BlueSection>
                  {this.state.scores.length ? (
                    <BlueSectionPlain>
                      {hasPermission(this.props.appUser.permissions, [
                        permissions.VIEW_SCORES,
                      ]) && (
                        <CategoryScores
                          editing={this.state.editing}
                          stateScores={this.state.scores}
                          handleUpdateScores={this.handleUpdateScores}
                          scores={this.props.displayCategoriesScores}
                          title="Scores by Display Category"
                          propertyKey="categoryName"
                          scoresLoaded={this.props.scoresLoaded}
                          modifyAll={modifyAll}
                        />
                      )}
                    </BlueSectionPlain>
                  ) : null}

                  <BlueSpacer />

                  <Wrapper>
                    <Column width={width} justify={"start"}>
                      <RequestInfo
                        request={request}
                        editing={this.state.editing}
                        handleUpdateTextField={handleChange}
                        handleUpdateSelect={handleChange}
                        handleDateChange={this.handleDateChange}
                        values={values}
                        setFieldValue={setFieldValue}
                        handleChange={handleChange}
                        appUser={appUser}
                      />
                      <SponsorInfo
                        originalSponsor={request.sponsorInformation}
                        request={request}
                        selectedSponsor={values.sponsorInformation}
                        setFieldValue={setFieldValue}
                        editing={this.state.editing}
                        appUser={appUser}
                      />
					  <DepartmentalReviews
                        request={request}
                        prescreenAccepted={prescreenAccepted}
												departments={this.props.departments}
												openReview={this.openDepartmentalReview}
												appUser={appUser}
												sendNotice={this.handleSendReviewNotice}
					  />
                      <PrescreenInfo
                        vendorRequestID={this.props.match.params.requestID}
                        request={request}
                        prescreenAccepted={prescreenAccepted}
                      />
                    </Column>
                    {hasPermission(appUser.permissions, [
                      permissions.VIEW_REQUEST_ATTACHMENT,
                      permissions.VIEW_ALL_REQUEST_ATTACHMENT,
                    ]) && (
                      <Column width="35%" justify="flex-start">
                        <Notes
                          vendorRequestID={this.props.match.params.requestID}
                        />
                        <Documents
                          vendorRequestID={this.props.match.params.requestID}
                          permissions={this.props.appUser.permissions}
                        />
						<AuditLog
                          vendorRequestID={this.props.match.params.requestID}
						/>
                        {/* <StatusLog
                          vendorRequestID={this.props.match.params.requestID}
                        /> */}
                      </Column>
                    )}
                  </Wrapper>
                  <QuestionnaireInfo
                    vendorRequestID={this.props.match.params.requestID}
                    requestStatus={this.props.request.requestStatus}
                    requestAproval={requestAproval}
                  />
                </Container>
              </Form>
            )}
          </Formik>
		  {/* <button onClick={() => testReviewAPI(this.props.match.params.requestID, "newreviews")}>New Thing to Review!</button><br />
		  <button onClick={() => testReviewAPI(this.props.match.params.requestID, "reviewsdone")}>Reviewing is Done</button><br /> */}
          <DialogWrapper
            isOpen={this.state.inactivateAssessment}
            onClose={this.handleDismissInactivateAssessment}
            title={'Inactivate Assessment'}
            body={
              'Inactive Assessments cannot be modified and will remain visible for historical purposes. Select Inactivate if you would like to continue.'
            }
            confirm={'Inactivate'}
            action={this.handleInactivate}
          />
			<DepartmentalReviewDrawer
				isOpen={this.state.departmentalReviewOpen}
				closeDrawer={this.closeDepartmentalReview}
				handleSave={this.handleSaveReview}
				departments={this.props.departments}
				review={this.state.selectedReview}
			/>
        </React.Fragment>
      );
    } else {
      return <Loading size={200} />;
    }
  }
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 760px),
    (min-width: 761px) and (max-width: 1024px) {
    flex-direction: column;
  }
`;

const Column = styled.div`
  margin-top: -5.5rem;
  display: flex;
  flex-direction: column;
  justify-content: ${props => props.justify || 'space-between'};
  width: ${props => props.width || '50%'};
  @media only screen and (max-width: 760px),
    (min-width: 761px) and (max-width: 1024px) {
    width: 100%;
    &:nth-child(2) {
      margin-top: 0rem;
    }
  }
`;

const BlueSection = styled.section`
  width: 100%;
  background: ${colors.brandingPrimary};
  color: #fff;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-around;
  padding: 2rem;
  @media (max-width: 1400px) {
    flex-direction: column;
  }
`;

const BlueSectionPlain = styled.section`
  width: 100%;
  background: ${colors.brandingPrimary};
  color: #fff;
  padding: 2rem;
  @media (max-width: 1400px) {
    flex-direction: column;
  }
`;

const BlueSpacer = styled.div`
  width: 100%;
  background: ${colors.brandingPrimary};
  height: 8rem;
`;

const mapStateToProps = state => ({
  request: state.vendorRequest.singleRequest,
  isFetching: state.vendorRequest.requestLoading,
  loaded: state.vendorRequest.requestLoaded,
  isError: state.vendorRequest.errorMessage,
  questionTypeScores: state.questionnaire.questionTypeScores,
  displayCategoriesScores: state.questionnaire.displayCategoriesScores,
  scoresLoaded: state.questionnaire.scoresLoaded,
  requestStatuses: state.utils.requestStatus,
  appUser: state.auth.appUser,
  departments: state.utils.departments,
});

ManageVendorRequest = connect(mapStateToProps, {
  ...actions,
  fetchAllDepartments,
  fetchScores,
  fetchUploadedFiles,
})(ManageVendorRequest);

export default ManageVendorRequest;
